// Minimal stub to satisfy bundling; the feature uses Nunjucks/inline markup.
export default {
  name: 'info-notice'
}
